<template>
  <div class="signin" @keydown.enter="handleSubmit">
    <div class="wrap">
      <div class="il">
        <div class="mask"></div>
        <div class="logo" v-if="!config.hideLogo"></div>
      </div>
      <div class="form-con box">
        <h2>{{config.title}}</h2>
        <Form ref="loginForm" :model="form" :rules="rules" label-position="top">
          <FormItem prop="account" label="用户名">
            <Input size="large" prefix="ios-person-outline" class="sl-input" v-model="form.account" placeholder="请输入用户名">
            <!-- <span slot="prepend">
                <Icon :size="16" type="person"></Icon>
              </span> -->
            </Input>
          </FormItem>
          <FormItem prop="password" label="登录密码">
            <Input size="large" prefix="ios-lock-outline" class="sl-input" type="password" v-model="form.password" placeholder="请输入密码">
            <!-- <span slot="prepend">
                <Icon :size="16" type="locked"></Icon>
              </span> -->
            </Input>
          </FormItem>
          <FormItem>
            <div class="action">
              <Checkbox :value="autoSignin" @on-change="handleChangeSignin">下次自动登录</Checkbox>
              <a href="">忘记密码</a>
            </div>
          </FormItem>
          <FormItem>
            <Button shape="circle" :loading="loading" @click="handleSubmit" type="primary" long size="large">登录</Button>
          </FormItem>
        </Form>
      </div>
    </div>
    <div class="ft">
      <p>{{config.footer}}<a style="color: #aaa;" target="_blank" href="https://beian.miit.gov.cn/">{{ config.icp }}</a></p>
    </div>
    <a @click="setDevDialog()" v-if="isdev" style="position: absolute;color:#fff;top:15px;right:15px">开发设置</a>
    <Modal v-model="visibleDevSetter" title="开发设置" width="80" :footer-hide="true" :mask-closable="false">
      <dev></dev>
    </Modal>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import dev from '../common/debug/dev'
import config from '../../config'

const isdev = process.env.NODE_ENV == 'development'
export default {
  components: { dev },
  data() {
    return {
      form: {
        account: '',
        password: '',
        terminal: 1,
      },
      rules: {
        account: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      },
      config:config,
      visibleDevSetter: false,
      isdev: isdev,
      loading: false
    }
  },
  computed: {
    ...mapState({
      autoSignin: state => state.autoSignin,
    }),
  },
  created() {
    if (this.autoSignin) {

    }
  },
  methods: {

    handleSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('auth/signin', this.form).then((res) => {
            if (res.code == 0) {
              this.$router.direct()
            } else if (res.code != -1) {
              this.$Message.error(res.msg)
            }
            this.loading = false
          })
        }
      })
    },
    handleChangeSignin(val) {
      this.$store.dispatch('setAutoSignin', !!val)
    },

    setDevDialog() {
      this.visibleDevSetter = true
    }
  }
}

</script>
